module["exports"] = [
  "s.r.o.",
  "a.s.",
  "v.o.s."
];
